import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from '@drl/shared/shared.module';

import {MainRoutingModule} from './main-routing.module';
import {MainComponent} from './main.component';
import {ThemeModule} from '@drl/theme/theme.module';
import {CsvUploadReportComponent} from './csv-upload-report/csv-upload-report.component';
import {AppointmentsReportComponent} from './csv-upload-report/components/appointments-report/appointments-report.component';
import {PatientsReportComponent} from './csv-upload-report/components/patients-report/patients-report.component';
import {TherapyPlansReportComponent} from './csv-upload-report/components/therapy-plans-report/therapy-plans-report.component';
import {PrescriptionsReportComponent} from './csv-upload-report/components/prescriptions-report/prescriptions-report.component';
import {SupportBoxModule} from '../support/support.module';
import { DataUploadComponent } from './data-upload/data-upload.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MainComponent,
    CsvUploadReportComponent,
    AppointmentsReportComponent,
    PatientsReportComponent,
    TherapyPlansReportComponent,
    PrescriptionsReportComponent,
    DataUploadComponent
  ],
  imports: [CommonModule, MainRoutingModule, SharedModule, ThemeModule, SupportBoxModule],
})
export class MainModule {}
